import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
  DropdownMenuLabel,
} from "@/components/ui/dropdown-menu";
import { Plus, Type, Image, Columns, Layers, GalleryHorizontal, Megaphone, MousePointerClick, List, Quote, LayoutGrid, AlertTriangle, CheckCircle, BarChart3, Tag, Sparkles } from "lucide-react";

const BLOCK_TYPES = [
  { type: "text_section", label: "Text Section", icon: Type, group: "content" },
  { type: "two_column", label: "Two Column", icon: Columns, group: "content" },
  { type: "quote", label: "Quote", icon: Quote, group: "content" },
  { type: "bullet_list", label: "Bullet List", icon: List, group: "content" },
  { type: "image", label: "Image", icon: Image, group: "media" },
  { type: "gallery", label: "Gallery", icon: GalleryHorizontal, group: "media" },
  { type: "image_hotspot", label: "Image Hotspot", icon: MousePointerClick, group: "media" },
  { type: "material_reference", label: "Material Reference", icon: Layers, group: "materials" },
  { type: "material_strategy", label: "Material Strategy", icon: Sparkles, group: "materials" },
  { type: "specs", label: "Specifications", icon: LayoutGrid, group: "data" },
  { type: "challenges", label: "Challenges", icon: AlertTriangle, group: "data" },
  { type: "outcomes", label: "Outcomes", icon: CheckCircle, group: "data" },
  { type: "result", label: "Result", icon: BarChart3, group: "data" },
  { type: "scenarios", label: "Scenarios", icon: Tag, group: "data" },
  { type: "cta", label: "Call to Action", icon: Megaphone, group: "content" },
] as const;

interface BlockTypeSelectorProps {
  onAdd: (type: string) => void;
}

export function BlockTypeSelector({ onAdd }: BlockTypeSelectorProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2 font-sans text-xs uppercase tracking-wider">
          <Plus size={14} /> Add Block
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {BLOCK_TYPES.map(({ type, label, icon: Icon }) => (
          <DropdownMenuItem key={type} onClick={() => onAdd(type)} className="gap-2 font-sans text-sm">
            <Icon size={14} />
            {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
